import React, { Component } from 'react';
import './MapComponent.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { Stage, Layer, Star, Text, Rect,Circle, Arrow } from 'react-konva';

class MapComponent  extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            
        };
    }

    render() {
        let rounds =  _.map(this.props.getInfluencerMapGroupsData.Items[0].groupsMap, (rect, i) => {
            if( rect.type === 'Circle'){
                
                return ( 
                    <Circle
                        key={i}
                        ref={rect.subName ? ref=>this[`${rect.name}`]=ref : ref=>this[`${rect.name}`]=ref}
                        x={rect.x}
                        y={rect.y}
                        scaleX={rect.scaleX}
                        scaleY={rect.scaleY}
                        width={rect.width}
                        height={rect.height}
                        fill={rect.fill}
                        name={rect.name}
                        type={rect.type}
                        subtype={rect.subtype}
                        stroke =  {rect.stroke}
                        strokeWidth={rect.strokeWidth}
                        draggable={false}
                        dash={rect.dash}
                        resizeEnabled={true}
                        onTransform={this.transformAdjustPoint}
                        context={rect.context}
                    />
                )
            }
            
        });
    
        let arrow =  _.map(this.props.getInfluencerMapGroupsData.Items[0].groupsMap, (rect, i) => {
            if( rect.type === 'Arrow' ){
                return ( 
                    <Arrow
                        x={rect.x}
                        y={rect.y}
                        width={rect.width}
                        height={rect.height}
                        fill={rect.fill}
                        name={rect.name}
                        stroke =  {rect.stroke}
                        strokeWidth={rect.strokeWidth}
                        draggable={false}
                        rotation={rect.rotation}
                        scaleX={rect.scaleX}
                        scaleY={rect.scaleY}
                        // onDragStart={this.handleDragStart}
                        // onDragEnd={}
                        resizeEnabled={true}
                        points={rect.points}
                        pointerLength= {rect.pointerLength}
                        pointerWidth = {rect.pointerWidth}
                        dash={rect.dash}
                        pointerAtBeginning={rect.pointerAtBeginning}
                    /> 
                )
            }
            
        }); 
    
        let circleTexts =  _.map(this.props.getInfluencerMapGroupsData.Items[0].groupsMap, (rect, i) => {
            if( rect.type === 'Text'){
                return ( 
                    <Text
                        key={i}
                        ref={ref=>this[`${rect.name}`]=ref}
                        x={rect.x}
                        y={rect.y}
                        scaleX={rect.scaleX}
                        scaleY={rect.scaleY}
                        width={rect.width}
                        height={rect.height}
                        fill={rect.fill}
                        name={rect.name}
                        type={rect.type}
                        subtype={rect.subtype}
                        stroke =  {rect.stroke}
                        strokeWidth={rect.strokeWidth}
                        draggable={false}
                        dash={rect.dash}
                        resizeEnabled={true}
                        onTransform={this.transformAdjustPoint}
                        text={rect.text}
                        fontSize={15}
                        align="center"
                        fontFamily= 'Calibri'
    
                    />
                )
            }
            
        });
    
    
        return (
            <Stage 
                width={this.props.convaWidth}
                height={700}
                ref={ref=>this.stage=ref}
                
            >
                <Layer ref={ref=>this.layer=ref}>
                    {rounds}
                    {circleTexts}
                    {arrow}
                </Layer>
            </Stage>
        );
    }
}

export default (MapComponent);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/InfluencerMapSelects/MapComponent/MapComponent.jsx